module.exports = __webpack_public_path__ + "img/tick.c0cbd084.svg";